import PersonalBillinglInfo from "./PersonalBillinglInfo";

export default PersonalBillinglInfo;
